export default function CTA() {
  return (
    <section className="py-24 px-8 md:px-16 lg:px-24 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Image Container */}
        <div className="rounded-3xl overflow-hidden mb-16 shadow-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=Happy%20diverse%20family%20standing%20in%20front%20of%20their%20beautiful%20new%20modern%20home%20with%20professional%20moving%20assistance%20team%20in%20background%2C%20bright%20sunny%20day%2C%20welcoming%20atmosphere%2C%20professional%20real%20estate%20photography%2C%20warm%20and%20inviting%20scene%2C%20successful%20home%20relocation%2C%20contemporary%20suburban%20house%20with%20manicured%20lawn&width=1200&height=600&seq=cta-001&orientation=landscape"
            alt="Happy Family New Home"
            className="w-full h-96 object-cover object-top"
          />
        </div>

        {/* Text Content */}
        <div className="text-center mb-12">
          <div className="text-4xl md:text-5xl leading-tight mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            <span className="text-gray-400 italic font-light">Ready to</span>
          </div>
          <div className="text-4xl md:text-5xl leading-tight mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            <span className="text-gray-400 italic font-light">simplify your</span>
          </div>
          <div className="text-4xl md:text-5xl leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
            <span className="text-gray-900 font-bold">corporate relocation?</span>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center">
          <button className="group bg-gray-900 hover:bg-gray-800 text-white px-12 py-5 rounded-full text-lg font-medium transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl flex items-center gap-3 whitespace-nowrap">
            Get Started Today
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>

        {/* Additional Info */}
        <div className="text-center mt-12">
          <p className="text-gray-500 text-base">
            Schedule a free consultation with our relocation experts
          </p>
        </div>
      </div>
    </section>
  );
}
